export default function Collapse() {
  return {}
}
